import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { UpdateTableViewParams } from './types';

export async function updateTableView(
  id: string,
  params: UpdateTableViewParams,
): Promise<{ success: boolean; error?: string }> {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${id}`,
      {
        method: 'POST',
        body: params,
      },
      undefined
    );

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || 'Failed to update table view',
      };
    }

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: 'Failed to update table view',
    };
  }
}
